export default "__VITE_ASSET__DDpvP51V__"